/*
 Copyright(c) 2018, iovation, inc. All rights reserved. 80808bae-d4c3-47ac-9929-5d77264d823c
*/
(function Ta() {
	function Ua() {
		var a = {optional: [{RtpDataChannels: !0}]},
			b,
			c,
			d;
		if (
			(b =
				('function' === typeof n.RTCPeerConnection && n.RTCPeerConnection) ||
				('function' === typeof n.mozRTCPeerConnection &&
					n.mozRTCPeerConnection) ||
				('function' === typeof n.webkitRTCPeerConnection &&
					n.webkitRTCPeerConnection))
		) {
			e.add('RTCT', b.name);
			d = Ba();
			try {
				d && d.sa
					? (c = new b(d.sa, a))
						? ((c.onicecandidate = function (a) {
								var b = d.bb;
								a &&
									a.target &&
									a.target.localDescription &&
									a.target.localDescription.sdp &&
									(a = a.target.localDescription.sdp) &&
									((a = p.encode(A.P(a.substring(0, 2e3)))),
									e.add('RTCSDP', a),
									e.add('RTCH', b));
						  }),
						  (c.onerror = Ca),
						  c.createDataChannel(''),
						  c.createOffer && 0 === c.createOffer.length
								? c
										.createOffer()
										.then(function (a) {
											'object' === typeof a &&
												c
													.setLocalDescription(a)
													.then(function () {})
													['catch'](Da);
										})
										['catch'](Ea)
								: c.createOffer &&
								  c.createOffer(function (a) {
										'object' === typeof a &&
											c.setLocalDescription(a, function () {}, Da);
								  }, Ea))
						: e.add('RTCERR', b.name + ' not instantiated')
					: e.add('RTCERR', 'RTCOptions failed to generate');
			} catch (H) {
				e.add('RTCERR', k('pmc: ', H, !0));
			}
		} else
			try {
				if (n.RTCIceGatherer) {
					var h;
					d = Ba();
					h = new n.RTCIceGatherer(d);
					e.add('RTCT', 'RTCIceGatherer');
					h.onlocalcandidate = function (a) {
						a.candidate &&
							((sa += JSON.stringify(a.candidate) + ';'), e.add('ORTCC', sa));
					};
					h.onerror = Ca;
				}
			} catch (H) {
				e.add('RTCERR', k('rtcig: ', H, !0));
			}
	}
	function Ca(a) {
		e.add('RTCERR', a ? 'onerror: ' + a : 'onerror');
	}
	function Da(a) {
		e.add('RTCERR', a ? 'sld: ' + a : 'sld');
	}
	function Ea(a) {
		e.add('RTCERR', a ? 'co: ' + a : 'co');
	}
	function Ba() {
		var a, b, c, d, h;
		g[f.Aa] &&
			((b = g[f.Aa].split(',')),
			1 < b.length
				? ((c = Math.floor(Math.random() * b.length)), (b = b[c]))
				: (b = b[0]),
			b &&
				((a = {iceServers: [{}]}),
				(h = a.iceServers[0]),
				(c = b.split('@')),
				1 < c.length
					? ((d = p.decode(c[0])),
					  d[1]
							? ((h.username = d[0]), (h.credential = d[1]))
							: d[0] && (h.credential = d[0]),
					  (h.urls = c[1]))
					: (h.urls = c[0])));
		return {ab: b, sa: a};
	}
	function ta() {
		var a = !0,
			b,
			c,
			d;
		try {
			for (d = X.length, b = 0; b < d; b++)
				if (((c = Y[X[b]]), 'object' === typeof c && (!c.h || (c.h && !c.w))))
					try {
						c.X();
					} catch (h) {
						(c.h = !1),
							k('domReadyHandler: unable to complete handler setup', h, !0),
							(a = !1);
					}
		} catch (h) {
			k('domReadyHandler: error in dom ready handler', h, !0);
		}
		return a && e.cb;
	}
	function la(a, b) {
		'string' === typeof a && 'object' === typeof b && (X.push(a), (Y[a] = b));
	}
	function Fa(a) {
		var b = {isUnex: !0, scriptList: ''},
			c,
			d,
			h,
			e,
			f,
			g,
			l,
			p,
			n,
			L,
			F,
			m = Boolean('static' === a),
			B;
		a = S;
		m && (ma = document.URL.split('/').splice(0, 3).join('/'));
		try {
			c = (ma + '/').replace(/\/+$/, '/');
			d = c.match(/^(http|https):\/\/([^:\/]+)(:[0-9]+)?(\/.*)$/);
			h = d[1];
			e = d[2].replace(/\./g, '\\.');
			f = d[3] && ':80' !== d[3] && ':443' !== d[3] ? d[3] : '';
			g = '^(' + h + ':)?//' + e + f + '/';
			l = m
				? '([^\\?]*\\/)?(static_)?(wdp)\\.js(\\?.*)?$'
				: '([^\\?]*\\/)?(dyn_)?wdp\\.js(\\?.*)?$';
			p = new RegExp(g + l);
			l = new RegExp('^' + l);
			n = document.getElementsByTagName('script');
			for (L = 0; L < n.length; L++)
				if ((F = n.item(L).getAttribute('src') || ''))
					(B = F.split(':')[0]),
						'https' === B
							? (F = F.replace(':443/', '/'))
							: 'http' === B
							? (F = F.replace(':80/', '/'))
							: (B = ''),
						p.test(F)
							? (b.isUnex = !1)
							: ma && /^(?!(https?:)?\/\/).*$/i.test(F) && l.test(F)
							? (b.isUnex = !1)
							: l.test(F) &&
							  0 > F.indexOf(a) &&
							  (b.scriptList += F.split('?')[0] + ';');
			b.scriptList = b.scriptList.replace(/;$/, '');
		} catch (C) {
			k('', C, !0);
		}
		return b;
	}
	function Va() {
		function a(b) {
			var c = m.round(b.gamma, 4),
				d = m.round(b.beta, 4),
				h = m.round(b.alpha, 4),
				H = m.round(b.$a || b.webkitCompassHeading, 4);
			b = m.round(b.Za || b.webkitCompassAccuracy, 4);
			!e.b.ORPY &&
				(c || 0 === c || d || 0 === d || h || 0 === h) &&
				e.add('ORPY', c + ';' + d + ';' + h);
			e.b.CMPAS || (!H && !b) || e.add('CMPAS', (H + ';' + b).toString());
			e.b.ORPY && e.b.CMPAS && T('deviceorientation', a);
		}
		(da || void 0 === da) && D('deviceorientation', a);
	}
	function Wa() {
		function a(b) {
			var c, d, h;
			!e.b.AXEL &&
				b &&
				b.accelerationIncludingGravity &&
				((c = m.round(b.accelerationIncludingGravity.x, 4)),
				(d = m.round(b.accelerationIncludingGravity.y, 4)),
				(h = m.round(b.accelerationIncludingGravity.z, 4)),
				(c || 0 === c || d || 0 === d || h || 0 === h) &&
					e.add('AXEL', c + ';' + d + ';' + h));
			e.b.AXINT ||
				(b && b.interval && e.add('AXINT', m.round(b.interval, 2).toString()));
			e.b.AXEL && e.b.AXINT && T('devicemotion', a);
		}
		(da || void 0 === da) && D('devicemotion', a);
	}
	function Xa() {
		if (navigator.getBattery)
			navigator.getBattery().then(function (a) {
				a && a.level && e.add('BATL', a.level.toString());
			});
		else {
			var a = navigator.Wa || navigator.Ya || navigator.Xa;
			a && void 0 !== a.level && e.add('BATL', a.level.toString());
		}
	}
	function Ya() {
		function a(b) {
			!e.b.OFFLN &&
				b &&
				(e.add('OFFLN', (b.isTrusted || 'undefined').toString()),
				T('offline', a));
		}
		D('offline', a);
	}
	function na(a) {
		var b = '',
			c,
			d,
			h = a ? 'cr' : 'mr';
		try {
			if (a && n.Uint16Array && n.crypto)
				(c = new n.Uint16Array(8)), n.crypto.getRandomValues(c);
			else
				for (c = [], d = 0; 8 > d; d++)
					c.push(Math.floor(4096 * (1 + Math.random())));
			b =
				P(c[0]) +
				P(c[1]) +
				'-' +
				P(c[2]) +
				'-' +
				P(c[3]) +
				'-' +
				P(c[4]) +
				'-' +
				P(c[5]) +
				P(c[6]) +
				P(c[7]);
		} catch (e) {
			k(h + ' guid:', e, !0);
		}
		return b;
	}
	function P(a) {
		a = '0000' + a.toString(16);
		return a.substr(a.length - 4);
	}
	function Za() {
		var a,
			b,
			c,
			d = g.secure_websockets ? 'wss:' : 'ws:';
		ua = setTimeout(U, 5e3);
		try {
			n.WebSocket
				? ((a = S.replace(/http(s)?:\/\//i, d + '//') + '/star'),
				  (b = new n.WebSocket(a)),
				  (b.onmessage = function (a) {
						a && a.data && a.target.close
							? (e.add('WSTRIP', a.data.toString(), !0), a.target.close())
							: U();
				  }),
				  (b.onerror = function (a) {
						Ha = !0;
						a && a.data && a.target.close ? a.target.close() : U();
						k(p.decode('V1NUUklQIEVycm9yIEhhbmRsZXIgRmlyZWQ='), void 0, !0);
				  }),
				  (b.onclose = function (a) {
						var b;
						a &&
							Ha &&
							((b = a.reason ? ': ' + a.reason : ''),
							e.add('WSERR', a.code.toString() + b),
							k(
								p.decode('V1NUUklQIFNvY2tldCBDbG9zaW5nIHcvIGNvZGUgLSA=') +
									a.code +
									b,
								void 0,
								!0,
							));
						U();
				  }))
				: ((c = p.decode('d2luZG93LldlYlNvY2tldCBub3QgZGVmaW5lZA==')),
				  e.add('WSERR', c),
				  U(),
				  k(c, void 0, !0));
		} catch (h) {
			b && b.close(),
				e.add('WSERR', k(p.decode('V1NUUklQIENhdGNoIFRyaWdnZXJlZDo='), h, !0)),
				U();
		}
	}
	function U() {
		ua && clearTimeout(ua);
		J.qa = !0;
		J.a = J.h && J.qa;
	}
	function Ia(a) {
		try {
			var b = document.getElementsByTagName('head')[0],
				c = document.createElement('audio'),
				d,
				h,
				H;
			va = setTimeout(ea, 5e3);
			a
				? ((h = 'fp_ee746445-19b1-4818-9781-cc525c47b6de'),
				  (H =
						'data:audio/mpeg;base64,/+NIZ' +
						M('A', 23) +
						'WGluZwAAAA8AAAAAAAACQAB' +
						M('AQEB', 7) +
						'AQEC' +
						M('AgIC', 8) +
						M('AwMD', 8) +
						'AwP' +
						M('/', 32) +
						'8AAAAKTEFNRTMuOThyBCgAAAAAAAAAABQIJAbALQABmgAAAkDGbPj' +
						M('A', 149) +
						'/+MYZAAAAAGkAAAAAAAAA0gAAAAATEFNRTMuOTguMl' +
						M('V', 54) +
						'/+MYZDMAAAGkAAAAAAAAA0gAAAAA' +
						M('V', 68) +
						'/+MYZGYAAAGkAAAAAAAAA0gAAAAA' +
						M('V', 68)))
				: ((h = 'fp_67f84468-5d35-41ea-945f-b0efd4e01d13'),
				  (H = S + g[f.ra] + '?nocache=' + Math.random().toString()));
			b &&
				c &&
				S &&
				((c.id = c.name = h),
				(c.src = H),
				(c.preload = 'metadata'),
				(c.type = 'audio/mp3'),
				(c.muted = !0),
				(c.controls = !1),
				c.setAttribute &&
					((d = V + '.fp.' + f.ta),
					c.setAttribute(
						'onloadedmetadata',
						d + "('" + h + "'," + Boolean(a) + ')',
					),
					b.appendChild(c)));
		} catch (ka) {
			e.add('ATRIPERR', k('ATRIP init error:', ka, !0)), ea();
		}
	}
	function M(a, b) {
		var c = '';
		a && 'number' === typeof b && (c = Array(b + 1).join(a));
		return c;
	}
	function ea() {
		va && clearTimeout(va);
		J.Da = !0;
	}
	function E(a) {
		var b,
			c,
			d,
			h = '',
			H = '',
			f = '',
			g = '',
			l,
			n,
			p,
			L,
			F = {};
		try {
			h = a.changedTouches.item(0).identifier;
		} catch (q) {}
		try {
			H = 0 === a.button || a.button ? a.button : '';
			f = 0 === a.keyCode || a.keyCode ? a.keyCode : '';
			g = a.code || '';
			c = h + ';' + H + ';' + f + ';' + g;
			'keydown' === a.type || 'keyup' === a.type
				? ((d = 'kp'), (F.K = 'KEY'))
				: 'mousedown' === a.type || 'mouseup' === a.type
				? ((d = 'mc'), (F.K = 'CLICK'))
				: 'touchstart' === a.type || 'touchend' === a.type
				? ((d = 'tc'), (F.K = 'TOUCH'))
				: (d = a.type);
			if (d && -1 < d.toUpperCase().indexOf('MOVE'))
				F.K = d.toUpperCase()[0] + 'MOV';
			else if ('scroll' === d || 'wheel' === d) F.K = d.toUpperCase();
			N[d] || (N[d] = F);
			b = N[d];
			b.F = new Date().getTime();
			b.fa ||
				(a.pointerType
					? (e.b.PTYP || e.add('PTYP', a.pointerType),
					  T('pointerdown', E),
					  T('pointermove', E))
					: ((b.fa = b.F), (b.isTrusted = a.isTrusted)));
			if (/^(key|mouse)down$/.test(a.type) || 'touchstart' === a.type)
				(b.D = 'down'), (b.ea = a.type.replace('down', 'up'));
			else if (/^(key|mouse)up$/.test(a.type) || 'touchend' === a.type)
				(b.D = 'up'), (b.ea = a.type.replace('up', 'down'));
			b.count || (b.count = 0);
			N.ga && (N.la = !0);
			'wheel' !== d || 20 !== b.count + 1 || N.ga || ((N.la = !1), (N.ga = !0));
			var Ga = 20 > b.count || ('scroll' === a.type && !N.la);
			if (Ga) {
				if (b.D) {
					h = !1;
					try {
						if ('' !== c)
							if ((b.f || (b.f = {}), 'down' === b.D))
								b.f[c] || (b.f[c] = []),
									b.O || (b.O = []),
									20 > b.f[c].length && b.f[c].push(b.F),
									(h = Boolean(b.f[c] && 1 < b.f[c].length)),
									h || (b.count += 1),
									20 > b.O.length
										? (b.aa && !h && b.O.push(b.F - b.aa.time),
										  1 === b.f[c].length && (b.aa = {time: b.F, id: c}))
										: (delete b.f, delete b.aa);
							else if (
								'up' === b.D &&
								b.f &&
								b.f[c] &&
								(b.L || (b.L = []),
								20 > b.L.length && b.L.push(b.F - b.f[c][0]),
								b.f)
							) {
								var B = b.f[c],
									C = B.length;
								1 < C &&
									(b.M || (b.M = []),
									20 > b.M.length && b.M.push(B[1] - B[0]),
									2 < C &&
										(b.N || (b.N = []),
										20 > b.N.length && b.N.push(B[C - 1] - B[C - 2])));
								delete b.f[c];
							}
					} catch (q) {
						k('hbde:', q, !0);
					}
				} else b.count += 1;
				'wheel' !== d &&
					(b.D ||
						'scroll' === d ||
						(b.wa &&
							(b.U || (b.U = []), 20 > b.U.length && b.U.push(b.F - b.wa)),
						(b.wa = b.F)),
					a.screenX &&
						a.screenY &&
						'up' !== b.D &&
						(b.u || b.C || ((b.u = []), (b.C = [])),
						20 > b.u.length && (b.u.push(a.screenX), b.C.push(a.screenY))));
			} else delete b.f, delete b.aa, T(a.type, E), b.ea && T(b.ea, E), Ja(b);
			'down' !== b.D &&
				(Ga && Ja(b),
				b.L &&
					0 < b.L.length &&
					((l = a.type[0].toUpperCase() + 'DOWN'), e.add(l, Ka(b.L))),
				b.O &&
					0 < b.O.length &&
					((n = a.type[0].toUpperCase() + 'BTWN'), e.add(n, Ka(b.O))),
				b.M &&
					0 < b.M.length &&
					((p = Math.round(m.ca(b.M))), e.add('KDEL', p.toString())),
				b.N &&
					0 < b.N.length &&
					((L = Math.round(m.ca(b.N))), e.add('KREP', L.toString())));
		} catch (q) {
			k('re:', q, !0);
		}
	}
	function Ja(a) {
		var b, c, d, h, H, f, g;
		try {
			a &&
				a.K &&
				a.fa &&
				a.count &&
				((b = a.fa - wa + ';' + a.isTrusted + ';' + a.count),
				a.u &&
					a.C &&
					((c = m.round(m.I(a.u), 2)),
					(d = m.round(m.I(a.C), 2)),
					(b += ';' + c + ';' + d),
					a.U &&
						((h = m.round(m.max(a.u), 2)),
						(H = m.round(m.max(a.C), 2)),
						(f = m.round(m.Ea({u: a.u, C: a.C}), 4)),
						(g = Math.round(m.ca(a.U))),
						(b += ';' + h + ';' + H + ';' + f + ';' + g))),
				e.add(a.K, b));
		} catch (l) {
			k('bfsss:', l, !0);
		}
	}
	function Ka(a) {
		var b = '',
			c,
			d,
			h;
		try {
			a &&
				((c = m.round(m.I(a), 2)),
				(d = m.round(m.ca(a), 2)),
				(h = m.round(m.ka(a), 2)),
				(b = c + ';' + d + ';' + h));
		} catch (e) {
			k('bsssfa:', e, !0);
		}
		return b;
	}
	function La() {
		this.version = l.appVersion.trim();
		this.s = l.appName;
		this.H = void 0;
		this.attributes = [];
		this.Qa();
		'string' === typeof l.oscpu && 0 < l.oscpu.length
			? (this.R = l.oscpu)
			: ((this.R = l.platform), this.Ja());
		if (('string' !== typeof this.s || 1 > this.s.length) && this.H) {
			var a = this.H[0].split('/');
			a && ((this.s = a[0]), (this.version = 1 < a.length ? a[1] : ''));
		}
		this.Ia();
	}
	function Ma() {
		this.da = void 0;
		this.a = this.h = this.w = !1;
	}
	function Na(a) {
		this.a = this.h = this.w = !1;
		this.name = 'fp_' + a;
		this.B = '';
		this.label = 'io_ls:' + a;
	}
	function $a(a) {
		g[f.i] &&
			(g[f.i] && q.getElementById(g[f.i])
				? (q.getElementById(g[f.i]).value = a)
				: k(
						f.xa + '[ "' + f.i + '" ] or corresponding object is not defined',
						void 0,
						!0,
				  ));
	}
	function Z(a) {
		var b =
				/^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/,
			c = !0;
		if (
			!a ||
			'string' !== typeof a ||
			(44 !== a.length && 50 !== a.length) ||
			!b.test(a)
		)
			c = !1;
		return c;
	}
	function xa() {
		var a;
		wa &&
			((a = new Date().getTime()),
			(a = parseInt(a - wa, 10)),
			e.add('JIFFY', a.toString()),
			(a = !0));
		return a;
	}
	function D(a, b, c) {
		var d;
		c = void 0 === c ? n : c;
		try {
			c &&
				'string' === typeof a &&
				'function' === typeof b &&
				((d = g.ignore_events),
				!d || (d && -1 === d.indexOf(a))
					? c.addEventListener
						? c.addEventListener(a, b, oa)
						: c.attachEvent && c.attachEvent('on' + a, b)
					: d &&
					  -1 !== d.indexOf(a) &&
					  G(
							p.decode('ZXhjbHVkaW5nIA==') +
								a +
								p.decode('IGV2ZW50TGlzdGVuZXI='),
					  ));
		} catch (h) {
			k('', h, !0);
		}
	}
	function T(a, b) {
		var c, d;
		(c = void 0 === c ? n : c) &&
			'string' === typeof a &&
			'function' === typeof b &&
			((d = g.ignore_events), !d || (d && -1 === d.indexOf(a))) &&
			(c.removeEventListener
				? c.removeEventListener(a, b, oa)
				: c.detachEvent && c.detachEvent('on' + a, b));
	}
	function ya(a, b, c) {
		var d = !1;
		void 0 !== b &&
			null !== b &&
			((d = !0),
			('float' === c && isNaN(parseFloat(b))) ||
				('int' === c && isNaN(parseInt(b, 10))) ||
				('id' === c && !q.getElementById(b.toString())) ||
				('Array' === c && b.constructor !== Array) ||
				(c === f.l && typeof b !== f.l)) &&
			((d = !1),
			k(
				'config "' +
					a +
					'" with a value of "' +
					b +
					'" did not match expected type of "' +
					c +
					'" or referenced element did not exist.',
				'',
				!0,
			));
		return d;
	}
	function k(a, b, c) {
		var d = '',
			h = '',
			e = '',
			ka = '',
			l = '',
			n = '',
			p = '';
		a = a ? a.toString() + ' ' : '';
		b &&
			((d = b.name ? '[ name: ' + b.name + ' ] ' : ''),
			(h = b.Ha ? '[ errorObj: ' + b.Ha + ' ] ' : ''),
			(e = b.description ? '[ description: ' + b.description + ' ] ' : ''),
			(ka = b.message ? '[ message: ' + b.message + ' ] ' : ''),
			(l = b.lineNumber ? '[ line: ' + b.lineNumber + ' ] ' : ''),
			(n = b.fileName ? '[ file: ' + b.fileName.split('?')[0] + ' ] ' : ''));
		p = 'fp ' + a + d + h + e + ka + l + n;
		z[f.ba] = g[f.ba] = p;
		('boolean' === typeof c ? c : 1) && G(p.toString());
		return p.toString().slice(0, 400);
	}
	function aa(a) {
		var b,
			c = null !== a && void 0 !== a;
		!c || ('1' !== a.toString() && 'true' !== a.toString().toLowerCase())
			? !c ||
			  ('0' !== a.toString() && 'false' !== a.toString().toLowerCase()) ||
			  (b = !1)
			: (b = !0);
		return b;
	}
	function t(a, b, c, d) {
		var h,
			e = {};
		h = (d = typeof d === f.c ? d : !0) ? 'io_' + a : 'fp_' + a;
		c === f.c
			? typeof aa(g[a]) === f.c
				? ((e.source = 'fp'), (g[a] = aa(g[a])))
				: d && typeof aa(z[a]) === f.c
				? ((e.source = V), (g[a] = aa(z[a])))
				: typeof aa(n[h]) === f.c
				? ((e.source = 'window'), (g[a] = aa(n[h])))
				: ((e.source = 'default'), (g[a] = b))
			: (ya(a, g[a], c)
					? (e.source = 'fp')
					: d && ya(a, z[a], c)
					? ((e.source = V), (g[a] = z[a]))
					: ya(h, n[h], c)
					? ((e.source = 'window'), (g[a] = n[h]))
					: ((e.source = 'default'), (g[a] = b)),
			  'float' === c
					? (g[a] = parseFloat(g[a]))
					: 'int' === c && (g[a] = parseInt(g[a], 10)));
		e.value = g[a];
		e.sharable = d;
		e['default'] = b;
		g.configMeta[a] = e;
		g.configMeta.configIndex.push(a);
	}
	var n = window || this,
		V = n.io_global_object_name || 'IGLOO',
		z = (n[V] = n[V] || {}),
		g = (z.fp = z.fp || {}),
		ba = 'iofp'.replace('fp', ''),
		W,
		wa = new Date().getTime(),
		Oa = '',
		Ha = !1,
		O = -1,
		Y = {},
		X = [],
		I,
		pa,
		Pa,
		Q,
		G,
		za,
		fa,
		e,
		qa,
		Qa,
		ra,
		S,
		Ra = !1,
		ma,
		ca = '',
		Aa,
		ga,
		sa,
		ua,
		va,
		oa,
		N = {la: !0, ga: !1},
		da,
		ha,
		f = {
			ra: 'atrip_resource_name',
			i: 'bbout_element_id',
			c: 'boolean',
			J: 'combine_tp_fp_output',
			Y: 'flash_blacklist',
			m: 'flash_needs_update_handler',
			S: 'flash_resource_name',
			Z: 'flash_whitelist',
			l: 'function',
			ta: 'handleATRIPResponse',
			v: 'invalid token: ',
			ba: 'last_error',
			g: 'loader',
			xa: 'localNamespace',
			za: 'ripServerUrl',
			Ba: 'staticMain',
			fb: 'submit_element_id',
			gb: 'submit_form_id',
			Ta: 'submitlogin',
			eb: 'submitLoginUrl',
			V: 'trace_handler',
			Aa: 'rtcServerList',
		};
	W = g.staticVer = '5.2.2';
	var q = n.document,
		l = n.navigator;
	da = n.isSecureContext;
	(function () {
		var a = !1;
		try {
			var b = Object.defineProperty({}, 'passive', {
				get: function () {
					a = !0;
				},
			});
			n.addEventListener('test', null, b);
		} catch (c) {}
		oa = a ? {passive: !0, capture: !1} : !1;
		try {
			ga = Boolean(l && l.plugins);
		} catch (c) {
			ga = !1;
		}
		String.prototype.trim ||
			(String.prototype.trim = function () {
				return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
			});
		q.getElementById ||
			(document.getElementById = function (a) {
				var b, h, e, f;
				if (q.getElementsByTagName)
					for (h = q.getElementsByTagName('*'), e = h.length, f = 0; f < e; f++)
						'object' !== typeof h[f] ||
							(h[f].id !== a && h[f].name !== a) ||
							(b = h[f]);
				else 'object' === typeof a && a.tagName && (b = a);
				return b;
			});
		Array.prototype.indexOf ||
			(Array.prototype.indexOf = function (a, b) {
				var h,
					e,
					f,
					g = -1;
				if (null !== this)
					if (((e = Object(this)), (f = e.length >>> 0), 0 === f)) g = -1;
					else if (
						((h = Number(b) || 0), Infinity === Math.abs(h) && (h = 0), h >= f)
					)
						g = -1;
					else
						for (h = Math.max(0 <= h ? h : f - Math.abs(h), 0); h < f; )
							if (h in e && e[h] === a) {
								g = h;
								break;
							} else h++;
				return g;
			});
	})();
	g[f.ba] = '';
	g.configMeta = {configIndex: []};
	var A = {
			j: function (a, b) {
				var c = '',
					d;
				d = '';
				if (a && 'number' === typeof b) {
					a = a.toString();
					for (d = b - a.length; c.length < d; ) c += '0';
					d = c + a;
				}
				return d;
			},
			hb: function (a) {
				var b = '';
				a && (b = a.replace(/\//g, '-').replace(' ', 'T') + 'Z');
				return b;
			},
			La: function (a) {
				var b = '';
				a &&
					(b =
						a.getUTCFullYear() +
						'/' +
						A.j((a.getUTCMonth() + 1).toString(), 2) +
						'/' +
						A.j(a.getUTCDate().toString(), 2) +
						' ' +
						A.j(a.getUTCHours().toString(), 2) +
						':' +
						A.j(a.getUTCMinutes().toString(), 2) +
						':' +
						A.j(a.getUTCSeconds().toString(), 2) +
						'.' +
						A.j(a.getUTCMilliseconds().toString(), 3));
				return b;
			},
			na: function (a, b) {
				var c;
				c = '';
				'number' === typeof a &&
					b &&
					((c = a.toString(16)), (c = b ? A.j(c, b) : c));
				return c;
			},
			P: function (a) {
				var b = '',
					c,
					d,
					h,
					e;
				if (a)
					for (e = a.length, c = 0; c < e; c++)
						if (((d = a.charCodeAt(c)), 128 > d)) b += String.fromCharCode(d);
						else if (2048 > d)
							b +=
								String.fromCharCode(192 + (d >> 6)) +
								String.fromCharCode(128 + (d & 63));
						else if (65536 > d) {
							if (!(56320 <= d && 57344 > d)) {
								if (55296 <= d && 56320 > d)
									if (c + 1 >= e) continue;
									else if (((h = a.charCodeAt(++c)), 56320 > h || 56832 <= d))
										continue;
									else d = ((d - 55296) << 10) + (d - 56320) + 65536;
								b +=
									String.fromCharCode(224 + (d >> 12)) +
									String.fromCharCode(128 + ((d >> 6) & 63)) +
									String.fromCharCode(128 + (d & 63));
							}
						} else
							b +=
								String.fromCharCode(240 + (d >> 18)) +
								String.fromCharCode(128 + ((d >> 12) & 63)) +
								String.fromCharCode(128 + ((d >> 6) & 63)) +
								String.fromCharCode(128 + (d & 63));
				return b;
			},
		},
		p = {
			A: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
			Pa: function (a) {
				var b = !1;
				if (a)
					try {
						b =
							/^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/.test(
								a,
							);
					} catch (c) {
						k('isBase64: ', c, !0);
					}
				return b;
			},
			encode: function (a) {
				var b,
					c,
					d,
					h,
					e,
					f,
					g,
					l,
					k = '';
				if (a)
					if (n.btoa) k = btoa(a);
					else
						for (l = a.length, b = 0; b < l; b += 3)
							(c = a.charCodeAt(b)),
								(d = a.charCodeAt(b + 1)),
								(h = a.charCodeAt(b + 2)),
								(e = c >> 2),
								(c = ((c & 3) << 4) | (d >> 4)),
								(f = ((d & 15) << 2) | (h >> 6)),
								(g = h & 63),
								isNaN(d) ? (f = g = 64) : isNaN(h) && (g = 64),
								(k +=
									p.A.charAt(e) +
									p.A.charAt(c) +
									p.A.charAt(f) +
									p.A.charAt(g));
				return k;
			},
			decode: function (a) {
				var b = '',
					c = 0,
					d,
					h,
					e,
					f,
					g,
					l,
					m,
					q;
				if (a)
					if (n.atob && p.Pa(a)) b = n.atob(a);
					else
						try {
							for (l = m = q = h = e = f = g = b = '', d = a.length; c < d; )
								(h = p.A.indexOf(a.charAt(c++))),
									(e = p.A.indexOf(a.charAt(c++))),
									(f = p.A.indexOf(a.charAt(c++))),
									(g = p.A.indexOf(a.charAt(c++))),
									(l = (h << 2) | (e >> 4)),
									(m = ((e & 15) << 4) | (f >> 2)),
									(q = ((f & 3) << 6) | g),
									(b += String.fromCharCode(l)),
									64 !== f && (b += String.fromCharCode(m)),
									64 !== g && (b += String.fromCharCode(q)),
									(h = e = f = g = l = m = q = '');
						} catch (L) {
							k('', L, !0), (b = '');
						}
				return b;
			},
		};
	G = function (a) {
		if (typeof g[f.V] === f.l)
			try {
				var b = new Date();
				g[f.V](
					A.j(b.getHours(), 2) +
						':' +
						A.j(b.getMinutes(), 2) +
						':' +
						A.j(b.getSeconds(), 2) +
						'.' +
						A.j(b.getMilliseconds(), 3) +
						' fp_' +
						a,
				);
			} catch (c) {
				k('trace: ', c, !1);
			}
	};
	t('install_flash', !0, f.c);
	t(f.m, '', f.l);
	t(f.V, '', f.l);
	t('enable_rip', !0, f.c);
	t('enable_atrip', !0, f.c);
	t('enable_wstrip', !0, f.c);
	t('enable_rtc', !1, f.c);
	t('enable_ftoken', !0, f.c);
	t('enable_static_token', !0, f.c);
	t('enable_flash', !0, f.c);
	t(f.Y, [''], 'Array');
	t(f.Z, [''], 'Array');
	t('min_flash_in_firefox_version', '');
	t('min_flash_in_firefox_linux_version', '');
	t('min_flash_version', '', 'float');
	t(f.S, '/stm3.swf');
	t(f.ra, '/time.mp3');
	t('bb_max_len', 4e3, 'int');
	t(f.J, !0, f.c);
	t('bb_callback', '', f.l, g[f.J]);
	t(f.i, '', '', g[f.J]);
	t('secure_websockets', !0, f.c);
	t('ignore_events', [], 'Array');
	g[f.i] &&
		!document.getElementById(g[f.i]) &&
		k(p.decode('YmJvdXQgZWxlbWVudCBkaWQgbm90IGV4aXN0IGF0IHJ1bnRpbWU='), '', !0);
	t(f.g);
	g[f.g] && ((S = g[f.g].tp_host), (Ra = g[f.g].url_dots_to_dashes || !1));
	S = S || p.decode('aHR0cHM6Ly9tcHNuYXJlLmllc25hcmUuY29t');
	g[f.g] &&
		(g[f.g].uri_hook && (ha = g[f.g].uri_hook),
		(ra = !1 === z[f.g].fp_dyn),
		(Qa = !1 === z[f.g].fp_static));
	ha = ha || '/iojs';
	'/' !== g[f.S].charAt(0) && (g[f.S] = ('/' + g[f.S]).replace(/\/\//g, '/'));
	if (Qa || g[f.Ba])
		return (
			k(
				p.decode(
					'c3RhdGljIGV4aXRpbmcgYmVjYXVzZSBpdCBoYXMgYWxyZWFkeSBydW4gb3IgaXMgZGlzYWJsZWQ=',
				),
				'',
				!0,
			),
			!1
		);
	g[f.Ba] = Ta;
	typeof g[f.V] === f.l && G(p.decode('KioqOiBCZWdpbm5pbmcgZXhlY3V0aW9u'));
	(function () {
		try {
			var a = g[f.i] && q.getElementById(g[f.i]),
				b = a && a.form;
			b && D('submit', xa, b);
		} catch (c) {
			k('', c, !0);
		}
	})();
	var R = {
		oa: function (a) {
			if (!a) return '';
			a = a.toString();
			var b = a.length,
				c = '',
				d = 0,
				h = 0,
				e,
				f,
				g;
			for (e = 0; e < b; e++)
				(f = a.charCodeAt(e)),
					128 > f
						? h++
						: (g =
								127 < f && 2048 > f
									? String.fromCharCode((f >> 6) | 192) +
									  String.fromCharCode((f & 63) | 128)
									: String.fromCharCode((f >> 12) | 224) +
									  String.fromCharCode(((f >> 6) & 63) | 128) +
									  String.fromCharCode((f & 63) | 128)),
					g && (h > d && (c += a.slice(d, h)), (c += g), (d = h = e + 1));
			h > d && (c += a.slice(d, b));
			return c;
		},
		ja: function (a) {
			function b(a) {
				var b = '',
					c,
					d;
				for (c = 7; 0 <= c; c--)
					(d = (a >>> (4 * c)) & 15), (b += d.toString(16));
				return b;
			}
			function c(a, b) {
				return (a << b) | (a >>> (32 - b));
			}
			a = R.oa(a);
			var d,
				h,
				e = Array(80),
				f = 1732584193,
				g = 4023233417,
				l = 2562383102,
				p = 271733878,
				n = 3285377520,
				k,
				m,
				q,
				B,
				C;
			k = a.length;
			var t = [],
				r;
			for (d = 0; d < k - 3; d += 4)
				(h =
					(a.charCodeAt(d) << 24) |
					(a.charCodeAt(d + 1) << 16) |
					(a.charCodeAt(d + 2) << 8) |
					a.charCodeAt(d + 3)),
					t.push(h);
			switch (k % 4) {
				case 0:
					d = 2147483648;
					break;
				case 1:
					d = (a.charCodeAt(k - 1) << 24) | 8388608;
					break;
				case 2:
					d = (a.charCodeAt(k - 2) << 24) | (a.charCodeAt(k - 1) << 16) | 32768;
					break;
				case 3:
					d =
						(a.charCodeAt(k - 3) << 24) |
						(a.charCodeAt(k - 2) << 16) |
						(a.charCodeAt(k - 1) << 8) |
						128;
			}
			for (t.push(d); 14 !== t.length % 16; ) t.push(0);
			t.push(k >>> 29);
			t.push((k << 3) & 4294967295);
			r = t.length;
			for (a = 0; a < r; a += 16) {
				for (d = 0; 16 > d; d++) e[d] = t[a + d];
				for (d = 16; 79 >= d; d++)
					e[d] = c(e[d - 3] ^ e[d - 8] ^ e[d - 14] ^ e[d - 16], 1);
				h = f;
				k = g;
				m = l;
				q = p;
				B = n;
				for (d = 0; 19 >= d; d++)
					(C =
						(c(h, 5) + ((k & m) | (~k & q)) + B + e[d] + 1518500249) &
						4294967295),
						(B = q),
						(q = m),
						(m = c(k, 30)),
						(k = h),
						(h = C);
				for (d = 20; 39 >= d; d++)
					(C = (c(h, 5) + (k ^ m ^ q) + B + e[d] + 1859775393) & 4294967295),
						(B = q),
						(q = m),
						(m = c(k, 30)),
						(k = h),
						(h = C);
				for (d = 40; 59 >= d; d++)
					(C =
						(c(h, 5) + ((k & m) | (k & q) | (m & q)) + B + e[d] + 2400959708) &
						4294967295),
						(B = q),
						(q = m),
						(m = c(k, 30)),
						(k = h),
						(h = C);
				for (d = 60; 79 >= d; d++)
					(C = (c(h, 5) + (k ^ m ^ q) + B + e[d] + 3395469782) & 4294967295),
						(B = q),
						(q = m),
						(m = c(k, 30)),
						(k = h),
						(h = C);
				f = (f + h) & 4294967295;
				g = (g + k) & 4294967295;
				l = (l + m) & 4294967295;
				p = (p + q) & 4294967295;
				n = (n + B) & 4294967295;
			}
			return (b(f) + b(g) + b(l) + b(p) + b(n)).toLowerCase();
		},
		Ga: function (a, b) {
			G(p.decode('aW9jOiBiZWdpbm5pbmcgZW5jcnlwdGlvbg=='));
			var c = [
					16843776, 0, 65536, 16843780, 16842756, 66564, 4, 65536, 1024,
					16843776, 16843780, 1024, 16778244, 16842756, 16777216, 4, 1028,
					16778240, 16778240, 66560, 66560, 16842752, 16842752, 16778244, 65540,
					16777220, 16777220, 65540, 0, 1028, 66564, 16777216, 65536, 16843780,
					4, 16842752, 16843776, 16777216, 16777216, 1024, 16842756, 65536,
					66560, 16777220, 1024, 4, 16778244, 66564, 16843780, 65540, 16842752,
					16778244, 16777220, 1028, 66564, 16843776, 1028, 16778240, 16778240,
					0, 65540, 66560, 0, 16842756,
				],
				d = [
					-2146402272, -2147450880, 32768, 1081376, 1048576, 32, -2146435040,
					-2147450848, -2147483616, -2146402272, -2146402304, -2147483648,
					-2147450880, 1048576, 32, -2146435040, 1081344, 1048608, -2147450848,
					0, -2147483648, 32768, 1081376, -2146435072, 1048608, -2147483616, 0,
					1081344, 32800, -2146402304, -2146435072, 32800, 0, 1081376,
					-2146435040, 1048576, -2147450848, -2146435072, -2146402304, 32768,
					-2146435072, -2147450880, 32, -2146402272, 1081376, 32, 32768,
					-2147483648, 32800, -2146402304, 1048576, -2147483616, 1048608,
					-2147450848, -2147483616, 1048608, 1081344, 0, -2147450880, 32800,
					-2147483648, -2146435040, -2146402272, 1081344,
				],
				e = [
					520, 134349312, 0, 134348808, 134218240, 0, 131592, 134218240, 131080,
					134217736, 134217736, 131072, 134349320, 131080, 134348800, 520,
					134217728, 8, 134349312, 512, 131584, 134348800, 134348808, 131592,
					134218248, 131584, 131072, 134218248, 8, 134349320, 512, 134217728,
					134349312, 134217728, 131080, 520, 131072, 134349312, 134218240, 0,
					512, 131080, 134349320, 134218240, 134217736, 512, 0, 134348808,
					134218248, 131072, 134217728, 134349320, 8, 131592, 131584, 134217736,
					134348800, 134218248, 520, 134348800, 131592, 8, 134348808, 131584,
				],
				f = [
					8396801, 8321, 8321, 128, 8396928, 8388737, 8388609, 8193, 0, 8396800,
					8396800, 8396929, 129, 0, 8388736, 8388609, 1, 8192, 8388608, 8396801,
					128, 8388608, 8193, 8320, 8388737, 1, 8320, 8388736, 8192, 8396928,
					8396929, 129, 8388736, 8388609, 8396800, 8396929, 129, 0, 0, 8396800,
					8320, 8388736, 8388737, 1, 8396801, 8321, 8321, 128, 8396929, 129, 1,
					8192, 8388609, 8193, 8396928, 8388737, 8193, 8320, 8388608, 8396801,
					128, 8388608, 8192, 8396928,
				],
				g = [
					256, 34078976, 34078720, 1107296512, 524288, 256, 1073741824,
					34078720, 1074266368, 524288, 33554688, 1074266368, 1107296512,
					1107820544, 524544, 1073741824, 33554432, 1074266112, 1074266112, 0,
					1073742080, 1107820800, 1107820800, 33554688, 1107820544, 1073742080,
					0, 1107296256, 34078976, 33554432, 1107296256, 524544, 524288,
					1107296512, 256, 33554432, 1073741824, 34078720, 1107296512,
					1074266368, 33554688, 1073741824, 1107820544, 34078976, 1074266368,
					256, 33554432, 1107820544, 1107820800, 524544, 1107296256, 1107820800,
					34078720, 0, 1074266112, 1107296256, 524544, 33554688, 1073742080,
					524288, 0, 1074266112, 34078976, 1073742080,
				],
				l = [
					536870928, 541065216, 16384, 541081616, 541065216, 16, 541081616,
					4194304, 536887296, 4210704, 4194304, 536870928, 4194320, 536887296,
					536870912, 16400, 0, 4194320, 536887312, 16384, 4210688, 536887312,
					16, 541065232, 541065232, 0, 4210704, 541081600, 16400, 4210688,
					541081600, 536870912, 536887296, 16, 541065232, 4210688, 541081616,
					4194304, 16400, 536870928, 4194304, 536887296, 536870912, 16400,
					536870928, 541081616, 4210688, 541065216, 4210704, 541081600, 0,
					541065232, 16, 16384, 541065216, 4210704, 16384, 4194320, 536887312,
					0, 541081600, 536870912, 4194320, 536887312,
				],
				n = [
					2097152, 69206018, 67110914, 0, 2048, 67110914, 2099202, 69208064,
					69208066, 2097152, 0, 67108866, 2, 67108864, 69206018, 2050, 67110912,
					2099202, 2097154, 67110912, 67108866, 69206016, 69208064, 2097154,
					69206016, 2048, 2050, 69208066, 2099200, 2, 67108864, 2099200,
					67108864, 2099200, 2097152, 67110914, 67110914, 69206018, 69206018, 2,
					2097154, 67108864, 67110912, 2097152, 69208064, 2050, 2099202,
					69208064, 2050, 67108866, 69208066, 69206016, 2099200, 0, 2, 69208066,
					0, 2099202, 69206016, 2048, 67108866, 67110912, 2048, 2097154,
				],
				m = [
					268439616, 4096, 262144, 268701760, 268435456, 268439616, 64,
					268435456, 262208, 268697600, 268701760, 266240, 268701696, 266304,
					4096, 64, 268697600, 268435520, 268439552, 4160, 266240, 262208,
					268697664, 268701696, 4160, 0, 0, 268697664, 268435520, 268439552,
					266304, 262144, 266304, 262144, 268701696, 4096, 64, 268697664, 4096,
					266304, 268439552, 64, 268435520, 268697600, 268697664, 268435456,
					262144, 268439616, 0, 268701760, 262208, 268435520, 268697600,
					268439552, 268439616, 0, 268701760, 266240, 266240, 4160, 4160,
					262208, 268435456, 268701696,
				],
				q = R.Fa(a),
				t = 0,
				F = b.length,
				A = 0,
				B = [0, 32, 2],
				C,
				z,
				r,
				ia,
				x,
				v,
				u,
				y,
				w,
				D = '',
				E = '';
			try {
				for (b += '\x00\x00\x00\x00\x00\x00\x00\x00'; t < F; ) {
					v =
						(b.charCodeAt(t++) << 24) ^
						(b.charCodeAt(t++) << 16) ^
						(b.charCodeAt(t++) << 8) ^
						b.charCodeAt(t++);
					u =
						(b.charCodeAt(t++) << 24) ^
						(b.charCodeAt(t++) << 16) ^
						(b.charCodeAt(t++) << 8) ^
						b.charCodeAt(t++);
					r = ((v >>> 4) ^ u) & 252645135;
					u ^= r;
					v ^= r << 4;
					r = ((v >>> 16) ^ u) & 65535;
					u ^= r;
					v ^= r << 16;
					r = ((u >>> 2) ^ v) & 858993459;
					v ^= r;
					u ^= r << 2;
					r = ((u >>> 8) ^ v) & 16711935;
					v ^= r;
					u ^= r << 8;
					r = ((v >>> 1) ^ u) & 1431655765;
					u ^= r;
					v ^= r << 1;
					v = (v << 1) | (v >>> 31);
					u = (u << 1) | (u >>> 31);
					for (z = 0; 3 > z; z += 3) {
						y = B[z + 1];
						w = B[z + 2];
						for (C = B[z]; C !== y; C += w)
							(ia = u ^ q[C]),
								(x = ((u >>> 4) | (u << 28)) ^ q[C + 1]),
								(r = v),
								(v = u),
								(u =
									r ^
									(d[(ia >>> 24) & 63] |
										f[(ia >>> 16) & 63] |
										l[(ia >>> 8) & 63] |
										m[ia & 63] |
										c[(x >>> 24) & 63] |
										e[(x >>> 16) & 63] |
										g[(x >>> 8) & 63] |
										n[x & 63]));
						r = v;
						v = u;
						u = r;
					}
					v = (v >>> 1) | (v << 31);
					u = (u >>> 1) | (u << 31);
					r = ((v >>> 1) ^ u) & 1431655765;
					u ^= r;
					v ^= r << 1;
					r = ((u >>> 8) ^ v) & 16711935;
					v ^= r;
					u ^= r << 8;
					r = ((u >>> 2) ^ v) & 858993459;
					v ^= r;
					u ^= r << 2;
					r = ((v >>> 16) ^ u) & 65535;
					u ^= r;
					v ^= r << 16;
					r = ((v >>> 4) ^ u) & 252645135;
					u ^= r;
					v ^= r << 4;
					E += String.fromCharCode(
						v >>> 24,
						(v >>> 16) & 255,
						(v >>> 8) & 255,
						v & 255,
						u >>> 24,
						(u >>> 16) & 255,
						(u >>> 8) & 255,
						u & 255,
					);
					A += 8;
					512 === A && ((D += E), (E = ''), (A = 0));
				}
			} catch (I) {
				k('ioc: error while to encrypting', I, !0);
			}
			G(p.decode('aW9jOiBlbmNyeXB0aW9uIGNvbXBsZXRl'));
			return D + E;
		},
		Fa: function (a) {
			var b = [
					0, 4, 536870912, 536870916, 65536, 65540, 536936448, 536936452, 512,
					516, 536871424, 536871428, 66048, 66052, 536936960, 536936964,
				],
				c = [
					0, 1, 1048576, 1048577, 67108864, 67108865, 68157440, 68157441, 256,
					257, 1048832, 1048833, 67109120, 67109121, 68157696, 68157697,
				],
				d = [
					0, 8, 2048, 2056, 16777216, 16777224, 16779264, 16779272, 0, 8, 2048,
					2056, 16777216, 16777224, 16779264, 16779272,
				],
				e = [
					0, 2097152, 134217728, 136314880, 8192, 2105344, 134225920, 136323072,
					131072, 2228224, 134348800, 136445952, 139264, 2236416, 134356992,
					136454144,
				],
				f = [
					0, 262144, 16, 262160, 0, 262144, 16, 262160, 4096, 266240, 4112,
					266256, 4096, 266240, 4112, 266256,
				],
				g = [
					0, 1024, 32, 1056, 0, 1024, 32, 1056, 33554432, 33555456, 33554464,
					33555488, 33554432, 33555456, 33554464, 33555488,
				],
				k = [
					0, 268435456, 524288, 268959744, 2, 268435458, 524290, 268959746, 0,
					268435456, 524288, 268959744, 2, 268435458, 524290, 268959746,
				],
				l = [
					0, 65536, 2048, 67584, 536870912, 536936448, 536872960, 536938496,
					131072, 196608, 133120, 198656, 537001984, 537067520, 537004032,
					537069568,
				],
				n = [
					0, 262144, 0, 262144, 2, 262146, 2, 262146, 33554432, 33816576,
					33554432, 33816576, 33554434, 33816578, 33554434, 33816578,
				],
				p = [
					0, 268435456, 8, 268435464, 0, 268435456, 8, 268435464, 1024,
					268436480, 1032, 268436488, 1024, 268436480, 1032, 268436488,
				],
				m = [
					0, 32, 0, 32, 1048576, 1048608, 1048576, 1048608, 8192, 8224, 8192,
					8224, 1056768, 1056800, 1056768, 1056800,
				],
				q = [
					0, 16777216, 512, 16777728, 2097152, 18874368, 2097664, 18874880,
					67108864, 83886080, 67109376, 83886592, 69206016, 85983232, 69206528,
					85983744,
				],
				t = [
					0, 4096, 134217728, 134221824, 524288, 528384, 134742016, 134746112,
					16, 4112, 134217744, 134221840, 524304, 528400, 134742032, 134746128,
				],
				B = [0, 4, 256, 260, 0, 4, 256, 260, 1, 5, 257, 261, 1, 5, 257, 261],
				C = [32],
				A = [0, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 0],
				r,
				z,
				x,
				v = (r = 0),
				u,
				y =
					(a.charCodeAt(r++) << 24) |
					(a.charCodeAt(r++) << 16) |
					(a.charCodeAt(r++) << 8) |
					a.charCodeAt(r++),
				w =
					(a.charCodeAt(r++) << 24) |
					(a.charCodeAt(r++) << 16) |
					(a.charCodeAt(r++) << 8) |
					a.charCodeAt(r++);
			x = ((y >>> 4) ^ w) & 252645135;
			w ^= x;
			y ^= x << 4;
			x = ((w >>> -16) ^ y) & 65535;
			y ^= x;
			w ^= x << -16;
			x = ((y >>> 2) ^ w) & 858993459;
			w ^= x;
			y ^= x << 2;
			x = ((w >>> -16) ^ y) & 65535;
			y ^= x;
			w ^= x << -16;
			x = ((y >>> 1) ^ w) & 1431655765;
			w ^= x;
			y ^= x << 1;
			x = ((w >>> 8) ^ y) & 16711935;
			y ^= x;
			w ^= x << 8;
			x = ((y >>> 1) ^ w) & 1431655765;
			w ^= x;
			x = ((y ^ (x << 1)) << 8) | ((w >>> 20) & 240);
			y =
				(w << 24) |
				((w << 8) & 16711680) |
				((w >>> 8) & 65280) |
				((w >>> 24) & 240);
			w = x;
			a = A.length;
			for (u = 0; u < a; u++)
				A[u]
					? ((y = (y << 2) | (y >>> 26)), (w = (w << 2) | (w >>> 26)))
					: ((y = (y << 1) | (y >>> 27)), (w = (w << 1) | (w >>> 27))),
					(y &= -15),
					(w &= -15),
					(r =
						b[y >>> 28] |
						c[(y >>> 24) & 15] |
						d[(y >>> 20) & 15] |
						e[(y >>> 16) & 15] |
						f[(y >>> 12) & 15] |
						g[(y >>> 8) & 15] |
						k[(y >>> 4) & 15]),
					(z =
						l[w >>> 28] |
						n[(w >>> 24) & 15] |
						p[(w >>> 20) & 15] |
						m[(w >>> 16) & 15] |
						q[(w >>> 12) & 15] |
						t[(w >>> 8) & 15] |
						B[(w >>> 4) & 15]),
					(x = ((z >>> 16) ^ r) & 65535),
					(C[v++] = r ^ x),
					(C[v++] = z ^ (x << 16));
			return C;
		},
	};
	fa = function () {
		var a,
			b,
			c = X.length,
			d = !0,
			e = '';
		for (a = 0; a < c; a++)
			(b = Y[X[a]]),
				(e += X[a] + ': ' + b.a + '; '),
				'object' !== typeof b
					? k(
							f.xa + '.allComplete method not object: ' + fa.toString(),
							void 0,
							!0,
					  )
					: b.a || (d = !1);
		G(e);
		return d;
	};
	za = function (a, b, c) {
		var d;
		z[ba] && z[ba].getBlackbox && (d = z[ba].getBlackbox(!0, c));
		d &&
			d.blackbox &&
			((a = d.blackbox + ';' + a),
			(b = Boolean(!0 === b && !0 === d.finished)));
		return {blackbox: a, finished: b};
	};
	e = {
		va: '',
		G: '',
		$: '',
		ha: void 0,
		W: !0,
		b: {},
		o: [],
		T: g.bb_max_len,
		Ra: function () {
			var a = 0,
				b = '',
				c,
				d,
				h,
				f,
				g,
				k;
			f = e.T - 6;
			f = Math.floor(0.75 * f);
			f = f - ((f % 4) + 4) - 4;
			e.add('LOST', '0000;00000', 1);
			4e3 > e.T && e.remove('FFONTS');
			d = e.o.length;
			k = e.o.join('').length;
			for (h = c = 0; h < d; h++) c += e.b[e.o[h]].length;
			k = 8 * d + k + c;
			for (h = 0; h < d; h++)
				if (
					((c = e.o[h]),
					'string' === typeof c &&
						'string' === typeof e.b[c] &&
						((c =
							A.na(c.length, 4) +
							c.toUpperCase() +
							A.na(e.b[c].length, 4) +
							e.b[c]),
						(g = c.length),
						0 >= e.T || b.length + g + 3 < f))
				)
					a++, (b += c);
			b.length !== k || a !== d
				? ((h = k - b.length),
				  (d =
						A.j(d - a, 4) +
						';' +
						A.j((99999 >= h ? h : '100k+').toString(), 5)),
				  (b = b.replace('0004LOST000a0000;00000', '0004LOST000A' + d)))
				: (--a, (b = b.replace('0004LOST000a0000;00000', '')));
			return A.na(a, 4) + b;
		},
		ma: function () {
			var a = '',
				b = String.fromCharCode(124, 76, 69, 0, 99, 2, 200, 163),
				c,
				d;
			try {
				(c = R.Ga(b, e.Ra())),
					(d = '0400' + p.encode(c)),
					0 >= e.T || d.length <= e.T ? ((a = d), (e.va = d)) : (a = e.va);
			} catch (h) {
				k('', h, !0);
			}
			return a;
		},
		ua: function (a) {
			return a && 'string' === typeof a && 0 < a.length;
		},
		add: function (a, b, c) {
			e.ua(a) &&
				e.ua(b) &&
				((b = b.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, '')),
				(b = R.oa(b)),
				0 > e.o.indexOf(a) && (c ? e.o.unshift(a) : e.o.push(a)),
				e.b[a] !== b && ((e.b[a] = b), (e.W = !0), e.ia()));
		},
		remove: function (a) {
			var b;
			if (e.b[a]) {
				delete e.b[a];
				for (b = e.o.indexOf(a); 0 <= b; )
					e.o.splice(b, 1), (b = e.o.indexOf(a));
				e.W = !0;
				e.ia();
			}
		},
		append: function (a) {
			if ('string' === typeof a) {
				var b = 4,
					c = 0,
					d = Array(2),
					h,
					g,
					k = !1;
				for (g = a.length; b < g; ) {
					h = parseInt(a.substr(b, 4), 16);
					if (isNaN(h) || 0 > h) break;
					b += 4;
					c++;
					0 < h && ((d[(c - 1) % 2] = a.substr(b, h)), (b += h));
					if (0 === c % 2) {
						if ('FTOKEN' !== d[0] || Z(d[1])) {
							if ('FTOKEN' === d[0] || 'FTRIP' === d[0]) k = !0;
							e.add(d[0], d[1], k);
						} else e.add('FTERR', f.v + A.P(d[1]));
						d[0] = d[1] = '';
					}
				}
			}
		},
		ia: function () {
			'number' !== typeof e.ha &&
				(e.ha = setTimeout(function () {
					e.update();
				}, 100));
		},
		update: function () {
			var a = '',
				b = '',
				c,
				d,
				h = fa();
			try {
				if (e.W || h)
					xa(),
						e.add('JINT', e.G),
						e.G !== f.Ta &&
							(typeof g.bb_callback === f.l
								? ((e.G = 'callback'),
								  (g.cbflag = !0),
								  (a = e.ma()),
								  (b = h),
								  (e.$ = g.bb_callback))
								: g[f.i] &&
								  q.getElementById(g[f.i]) &&
								  ((e.G = 'form'), (a = e.ma()), (b = h), (e.$ = $a))),
						!0 === g[f.J] &&
							((d = za(a, b, e.G)), (a = d.blackbox), (b = d.finished)),
						e.$ && (e.$(a, b), (g.cbflag = !1)),
						(e.ha = void 0),
						(e.W = !1);
				c = !0;
			} catch (l) {
				k('io_bb.update', l, !0), (c = !1);
			}
			return c;
		},
	};
	e.ia();
	g.getBlackbox = function (a, b) {
		var c;
		typeof a !== f.c && (a = !1);
		z[ba] && z[ba].cbflag && (c = z[ba].cbflag);
		if (g.cbflag || (void 0 === b && c))
			c = {
				blackbox: p.decode(
					'SW52YWxpZCBJbnRlZ3JhdGlvbjogY2Fubm90IGNhbGwgZ2V0QmxhY2tib3ggZnJvbSBpbnNpZGUgYmJfY2FsbGJhY2su',
				),
				finished: fa(),
			};
		else if (
			((e.G = b || f.l),
			e.add('JINT', e.G),
			(c = {blackbox: e.ma(), finished: fa()}),
			!a)
		) {
			try {
				xa();
			} catch (d) {
				k('', d, !0);
			}
			g[f.J] && (c = za(c.blackbox, c.finished));
		}
		return c;
	};
	!0 === g[f.J] && (z.getBlackbox = g.getBlackbox);
	Na.prototype = {
		X: function () {
			G(p.decode('bHNwOiBMb2NhbFN0b3JhZ2UgY29sbGVjdGlvbiBzdGFydGluZy4uLg=='));
			this.h = !0;
			var a, b;
			try {
				n.localStorage &&
					(((a =
						n.localStorage.getItem(this.name) ||
						n.localStorage.getItem('fp_temp')),
					a)
						? O &&
						  (Z(a)
								? (n.localStorage.getItem(this.name) ||
										n.localStorage.setItem(this.name, a),
								  e.add('LSTOKEN', a, !0),
								  (this.B = a))
								: e.add('LSERROR', f.v + A.P(a)))
						: 1 === O &&
						  (Z(this.B)
								? (n.localStorage.setItem(this.name, this.B),
								  (b = n.localStorage.getItem(this.name)),
								  Z(b)
										? e.add('LSTOKEN', b, !0)
										: e.add(
												'LSERROR',
												p.decode('dG9rZW4gbm90IHBlcnNpc3Rpbmc='),
										  ))
								: e.add('LSERROR', f.v + A.P(this.B))));
			} catch (c) {
				e.add('LSERROR', k('', c, !0)),
					G(p.decode('bHNwOiBMb2NhbFN0b3JhZ2UgY29sbGVjdGlvbiBmYWlsZWQuLi4='));
			}
			this.a = !0;
			this.B && I && (this.w = !0);
			G(p.decode('bHNwOiBMb2NhbFN0b3JhZ2UgY29sbGVjdGlvbiBjb21wbGV0ZS4uLg=='));
		},
	};
	g._iov_fl_cb = function (a, b) {
		var c = Y.io_fdp;
		'0000' !== a
			? (G(p.decode('ZmRwOiBBZGRpbmcgYmIgZGF0YSBbIA==') + a + ' ]'),
			  e.append(a),
			  G(p.decode('ZmRwOiBkYXRhIGNvbGxlY3RlZCA=') + b))
			: G(p.decode('ZmRwOiBVcGRhdGluZyBibGFja2JveCAtIG5vIGRhdGE='));
		b &&
			((Y.io_fdp.a = !0), c && c.da && (clearTimeout(c.da), (c.da = void 0)));
		return !0;
	};
	g._iov_fl_fn = function (a) {
		var b = a.split(';'),
			c = '',
			d,
			h;
		e.add('JFLEN', b.length.toString());
		e.add('JFSTRL', a.length.toString());
		e.add('FFHASH', R.ja(a));
		for (a = 0; a < b.length; a++)
			(b[a] && b[a] && ' ' !== b[a]) || (b.splice(a, 1), a--);
		for (a = 1; a < b.length; a++)
			(d = Math.random() * a),
				(d = Math.floor(d)),
				d !== a && ((h = b[a]), (b[a] = b[d]), (b[d] = h));
		for (a = 0; 15 > a; a++) c += b[a] + ';';
		e.add('FFONTS', R.oa(c));
	};
	g._iov_fl_get_value = function (a) {
		var b = Y.io_fdp,
			c = '';
		'token' === a && O && g.enable_ftoken
			? (c = b.B)
			: 'rip' === a && g[f.za] && (c = g[f.za]);
		return c;
	};
	Ma.prototype = {
		Ka: function () {
			if (ga && (0 < l.plugins.length || l.plugins['Shockwave Flash'])) {
				if (l.plugins['Shockwave Flash 2.0'] || l.plugins['Shockwave Flash']) {
					var a = l.plugins['Shockwave Flash 2.0']
							? 'Shockwave Flash 2.0'
							: 'Shockwave Flash',
						b = l.plugins[a].version ? l.plugins[a].version : '',
						c = '';
					if (l.plugins[a] && l.plugins[a].description)
						var d = l.plugins[a].description.split(' '),
							a = -1 < d[2].indexOf(',') ? ',' : '.',
							c = d[2].split(a),
							d = '' !== d[3] ? d[3].split('r') : d[4].split('r'),
							c = c[0] + a + c[1] + a + (0 < d[1] ? d[1] : 0);
					return [c, b];
				}
			} else if (n.ActiveXObject)
				try {
					return (
						(b = new n.ActiveXObject('ShockwaveFlash.ShockwaveFlash')) &&
							(a = b.GetVariable('$version').split(' ')[1]),
						[a, '']
					);
				} catch (e) {
					k('', e, !0);
				}
			return ['', ''];
		},
		verify: function (a) {
			var b = a && q.getElementById(a);
			b && b.clientHeight && (1 !== b.clientHeight || 1 !== b.clientWidth)
				? (k('Script content area is hidden', void 0, !0),
				  e.add('JSFBLK', b.clientHeight + 'X' + b.clientWidth),
				  (this.a = !0),
				  G(p.decode('ZmRwOiBGbGFzaEJsb2NrIHRyaWdnZXJlZA==')))
				: g.enable_rip &&
				  !this.a &&
				  (this.da = setTimeout(function () {
						g._iov_fl_cb('00010008FTIMEOUT00011', !0, a);
				  }, 2e3));
		},
		ya: function () {
			var a = !1;
			(-1 < l.appName.indexOf('Microsoft') &&
				'loaded' !== q.readyState &&
				'complete' !== q.readyState &&
				'interactive' !== q.readyState) ||
				(a = !0);
			return a;
		},
		Ua: function (a) {
			var b, c, d;
			-1 < a.indexOf(',') && (a = a.replace(/,/g, '.'));
			b = I.fvbl;
			g[f.Y] && g[f.Y].constructor === Array && (b = b.concat(g[f.Y]));
			c = b.length;
			for (d = 0; d < c; d++) if (a === b[d]) return !0;
			return !1;
		},
		Va: function (a) {
			var b,
				c = g.min_flash_in_firefox_version || I.kgfffv,
				d = I.ffwl,
				e,
				k;
			-1 < a.indexOf(',') && (a = a.replace(/,/g, '.'));
			g[f.Z] && g[f.Z].constructor === Array && (d = d.concat(g[f.Z]));
			if (ga)
				for (k = l.plugins.length, b = 0; b < k; b++)
					(e = l.plugins[b]) &&
						'libflashplayer.so' === e.filename &&
						(c = g.min_flash_in_firefox_linux_version || I.kgffflv);
			e = a.split('.');
			c = c.split('.');
			k = e.length;
			for (b = 0; b < k; b++) e[b] = parseInt(e[b], 10);
			k = c.length;
			for (b = 0; b < k; b++) c[b] = parseInt(c[b], 10);
			if (
				e[0] > c[0] ||
				(e[0] === c[0] &&
					(e[1] > c[1] ||
						(e[1] === c[1] &&
							(e[2] > c[2] ||
								(e[2] === c[2] && void 0 !== e[3] && e[3] >= c[3])))))
			)
				return !0;
			b = d.length;
			for (e = 0; e < b; e++) if (((c = d[e]), a === c)) return !0;
			return !1;
		},
		Sa: function (a, b) {
			var c = a.split('/').pop();
			this.url = a;
			this.B = b;
			this.label = 'fp_' + c.split('.')[0];
		},
		X: function () {
			var a, b, c, d;
			if (this.ya() && I) {
				if (
					((a = parseFloat(g.min_flash_version || I.kgfv)),
					(b = O && Q ? Q : ''),
					ca)
				)
					if (
						(this.Sa(ca + g[f.S], b),
						G(p.decode('ZmRwOiBzZXR0aW5nIHVwIEZ4IGhhbmRsZXI=')),
						(b = this.Ka()),
						e.add('JFLVR', b[0]),
						e.add('JFFVER', b[1]),
						b[1] ? (b = b[1]) : b[0] ? (b = b[0]) : (b = ''),
						!b ||
							parseFloat(b) < a ||
							this.Ua(b) ||
							(-1 < l.userAgent.toLowerCase().indexOf('firefox') &&
								!this.Va(b)))
					) {
						try {
							if (g.install_flash && g[f.m]) {
								if (typeof g[f.m] === f.l) g[f.m]();
								delete g[f.m];
								z[f.m] && delete z[f.m];
								n['io_' + f.m] && delete n['io_' + f.m];
							}
						} catch (h) {
							e.add('FERR0', k(f.m, h, !0));
						}
						G(p.decode('ZmRwOiBGeCBoYW5kbGVyIGV4Y2x1ZGVk'));
						this.h = this.a = this.w = !0;
					} else
						try {
							G(p.decode('ZmRwOiBQdWxsaW5nIG9iamVjdCA=') + this.url),
								(c = q.createElement('span')),
								q.body.appendChild(c),
								(d =
									'<object classid="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000" width="1" height="1" id="' +
									this.label +
									'" name="' +
									this.label +
									'" align="right">'),
								(d += '<param name="allowScriptAccess" value="sameDomain" />'),
								(d += '<param name="movie" value="' + this.url + '" />'),
								(d += '<param name="swLiveConnect" value="true" />'),
								(d +=
									'<param FlashVars="globalNamespace=' +
									V +
									'&partyNamespace=fp" value="true" />'),
								(d += '<embed src="' + this.url),
								(d +=
									'" width="1" height="1" name="' +
									this.label +
									'" FlashVars="globalNamespace=' +
									V +
									'&partyNamespace=fp" swliveconnect="true" allowscriptaccess="sameDomain" type="application/x-shockwave-flash" pluginspage="https://get.adobe.com/flashplayer"'),
								(c.innerHTML = d + '/></object>'),
								(c.style.position = 'absolute'),
								(c.style.top = '-1000px'),
								(this.w = this.h = !0),
								this.verify(this.label);
						} catch (h) {
							(this.a = !0), e.add('FERR1', k('fdp.collect', h, !0));
						}
			} else
				this.ya()
					? ra || I
						? g[f.g] && g[f.g]['fp' + p.decode('X2R5bl93ZHBfbG9hZF9mYWlsdXJl')]
							? (this.a = !0)
							: ra && (this.a = !0)
						: g[f.g] && g[f.g]['fp' + p.decode('X2R5bl93ZHBfbG9hZF9mYWlsdXJl')]
						? ((this.a = !0), k('Dyn obj load failed!', void 0, !0))
						: k('Dyn obj not ready for Flash!', void 0, !0)
					: k('Env not ready for Flash!', void 0, !0);
		},
	};
	La.prototype = {
		Qa: function () {
			var a, b, c, d, e, f, g;
			if (l && l.userAgent) {
				a = l.userAgent.match(/\([^\)]*\)/g);
				b = a.length;
				if (a)
					for (c = 0; c < b; c++)
						if ((e = a[c].match(/[^;]*;?/g)))
							for (f = e.length, d = 0; d < f; d++)
								0 < e[d].length &&
									'undefined' !== typeof this.attributes &&
									((g = e[d].replace(/[\(\);]/g, '').trim()),
									this.attributes.push(g));
				this.H = l.userAgent.match(/([\w]+\s )?[^\s\/]*\/[^\s]*/g);
			}
		},
		Ia: function () {
			var a = 'MSIE Maxthon Minimo AOL Browser iCab Lunascape'.split(' '),
				b = a.length,
				c,
				d,
				e,
				f;
			if (this.attributes)
				for (f = this.attributes.length, c = 0; c < b; c++)
					for (
						e = new RegExp('^.*' + a[c] + ' ?[^0-9.]*', 'g'), d = 0;
						d < f;
						d++
					)
						if (
							0 <= this.attributes[d].toUpperCase().search(a[c].toUpperCase())
						) {
							this.version = this.attributes[d]
								.replace(e, '')
								.replace(/\s+/g, '');
							this.version === this.attributes[d] && (this.version = '');
							0 < c
								? ((c = new RegExp(this.version + '$', 'g')),
								  (this.s = this.attributes[d].replace(c, '')))
								: (this.s = 'Internet Explorer');
							return;
						}
			b =
				'Classilla;Gnuzilla;SeaMonkey;Maxthon;K-Meleon;Flock;Epic;Camino;Firebird;Conkeror;Fennec;Skyfire;MicroB;GranParadiso;Opera Mini;Netscape;Sleipnir;Browser;IceCat;weasel;iCab;Opera;OPR;OPiOS;Minimo;Konqueror;Galeon;Lunascape;Thunderbird;BonEcho;Navigator;Epiphany;Minefield;TizenBrowser;Namoroka;Shiretoko;NetFront;IEMobile;Puffin;Firefox;FxiOS;Edge;Chrome;CriOS;Safari;Mobile;Mobile Safari;Trident'.split(
					';',
				);
			e = b.length;
			if (this.H)
				for (f = this.H.length, c = 0; c < e; c++)
					for (d = 0; d < f; d++)
						if ((a = this.H[d].split('/')))
							if (
								(this.s ||
									((this.s = a[0]), (this.version = a[1].replace(';$', ''))),
								0 <= a[0].toUpperCase().search(b[c].toUpperCase()))
							) {
								this.s = a[0];
								this.version = a[1].replace(';$', '');
								return;
							}
		},
		Ja: function () {
			var a =
					'Linux;Windows Phone;Android;BSD;Ubuntu;Irix;MIDP;Xbox One;Xbox;Windows ;Mac OS X;Debian;Mac;Playstation;Wii;Win9;BlackBerry;WinNT;iPhone;iPad;OS'.split(
						';',
					),
				b = a.length,
				c,
				d,
				e,
				f;
			if (this.attributes)
				for (c = this.attributes.length, d = 0; d < b; d++)
					for (e = 0; e < c; e++)
						if (
							0 <=
								this.attributes[e].toUpperCase().search(a[d].toUpperCase()) &&
							((this.R = this.attributes[e]), 0 < d)
						)
							return;
			a =
				'BlackBerry;MIDP;Debian;Ubuntu;BSD;AIX;Irix;Gentoo;Fedora;Red Hat;OS'.split(
					';',
				);
			b = a.length;
			if ((c = this.H))
				for (f = c.length, d = 0; d < b; d++)
					for (e = 0; e < f; e++)
						if (0 <= c[e].toUpperCase().search(a[d].toUpperCase())) {
							this.R = c[e].replace('/', ' ').replace(/\s+/g, ' ');
							return;
						}
		},
	};
	var m = {
		max: function (a) {
			return a.sort()[a.length - 1];
		},
		round: function (a, b) {
			var c;
			'number' === typeof a &&
				'number' === typeof b &&
				((b = parseInt(b, 10)),
				(c = Math.pow(10, b)),
				(c = Math.round(a * c) / c));
			return c;
		},
		ca: function (a) {
			a = a.slice();
			var b = Math.floor(a.length / 2),
				c;
			0 === a.length
				? (c = null)
				: (a.sort(function (a, b) {
						return a - b;
				  }),
				  1 === a.length % 2 ? (c = a[b]) : (c = (a[b - 1] + a[b]) / 2));
			return c;
		},
		Ca: function (a) {
			var b = 0,
				c = a.length,
				d,
				e;
			for (e = 0; e < c; e++) (d = a[e]), (b += d);
			return b;
		},
		I: function (a) {
			return m.Ca(a) / a.length;
		},
		ka: function (a) {
			a = a.slice();
			var b = m.I(a),
				c,
				d = [],
				e = a.length,
				f;
			for (f = 0; f < e; f++)
				(c = a[f]), (c = c - b), (c = Math.pow(c, 2)), d.push(c);
			return Math.sqrt(m.Ca(d) / e);
		},
		Ea: function (a) {
			var b = a.u;
			a = a.C;
			var c = m.I(b),
				d = m.I(a),
				e = m.ka(b),
				f = m.ka(a),
				g = b.length,
				k,
				l,
				n = 0,
				p;
			if (0 === e * f) b = 1;
			else {
				for (p = 0; p < g; p++)
					(k = (b[p] - c) / e), (l = (a[p] - d) / f), (n += k * l);
				b = Math.abs(n / g);
			}
			return b;
		},
	};
	g[f.ta] = function (a, b) {
		try {
			var c = a && document.getElementById(a),
				d;
			c &&
				(d = c.duration) &&
				(b
					? (e.add('ATRIP', Oa + ';' + d.toString(), !0), ea())
					: ((Oa = d.toString()), Ia(!0)));
		} catch (f) {
			e.add('ATRIPERR', k('ATRIP response error:', f, !0)), ea();
		}
	};
	var ja = {
			a: !1,
			Ma: function (a) {
				var b = '',
					c,
					d,
					e = 'cr';
				try {
					(d = na(!0)),
						d || ((d = na(!1)), (e = 'mr')),
						d &&
							((c = a + ';' + d + ';' + e),
							(c += '?' + R.ja(c)),
							(b = p.encode(c)));
				} catch (f) {
					k('sttkn.gen:', f, !0);
				}
				return b;
			},
			pa: function (a, b) {
				var c = !1,
					d,
					e =
						/((1|2)[0-9]{3})\/((02)\/(0[1-9]|1[0-9]|2[0-9])|(0(1|3|5|7|8)|1(0|2))\/(0[1-9]|(1|2)[0-9]|3(0|1))|(0(4|6|9)|11)\/(0[1-9]|(1|2)[0-9]|30)) ((0|1)[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])\.[0-9]{3}/,
					f = /[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}/,
					g = /cr|mr/,
					l,
					n,
					m,
					q,
					t,
					A,
					z = !1,
					B,
					C,
					E,
					r,
					D,
					x;
				try {
					(a = p.decode(a)) &&
						(d = (l = a.split('?')[0]) && l.split(';')) &&
						3 === d.length &&
						((n = a.split('?')[1]),
						(m = R.ja(l)),
						n &&
							m === n &&
							((q = e.test(d[0])),
							(t = f.test(d[1])),
							(A = g.test(d[2])),
							q &&
								((C = d[0]),
								(r =
									/([0-9]{4})\/([0-9]{2})\/([0-9]{2}) ([0-9]{2}):([0-9]{2}):([0-9]{2}).([0-9]{3})/),
								(D = C.match(r)),
								(x = b.match(r)),
								(B = new Date(D[1], D[2], D[3], D[4], D[5], D[6], D[7])),
								(E = new Date(x[1], x[2], x[3], x[4], x[5], x[6], x[7])),
								(z = B <= E)),
							(c = q && z && A && t)));
				} catch (v) {
					k('sttkn.gen:', v, !0);
				}
				return c;
			},
			Na: function (a) {
				var b = '',
					c;
				try {
					n.localStorage &&
						((c = n.localStorage.getItem(
							'28214019-fad0-4a25-8f60-19885fb32f22',
						)),
						ja.pa(c, a)
							? (b = c)
							: (c && e.add('STERR', 'found ' + f.v + c),
							  (c = ja.Ma(a)),
							  ja.pa(c, a)
									? n.localStorage.setItem(
											'28214019-fad0-4a25-8f60-19885fb32f22',
											c,
									  )
									: c && e.add('STERR', 'generated ' + f.v + c),
							  (c = n.localStorage.getItem(
									'28214019-fad0-4a25-8f60-19885fb32f22',
							  )),
							  ja.pa(c, a)
									? (b = c)
									: c && e.add('STERR', 'refound ' + f.v + c)));
				} catch (d) {
					k('sttkn:', d, !0);
				}
				return b;
			},
		},
		J = {
			label: 'io_sdp',
			a: !1,
			h: !1,
			w: !0,
			Da: !1,
			qa: !1,
			Oa: function () {
				var a = new Date(2e3, 0, 1, 0, 0, 0, 0),
					b = a.toGMTString().split(' '),
					b = new Date(b.pop() && b.join(' ')),
					c = Math.round((b - a) / 6e4),
					a = new Date(2e3, 6, 1, 0, 0, 0, 0),
					b = a.toGMTString().split(' '),
					b = new Date(b.pop() && b.join(' ')),
					a = Math.round((b - a) / 6e4);
				return c > a ? c : a;
			},
			X: function () {
				if (!J.h)
					try {
						J.h = !0;
						var a,
							b,
							c,
							d,
							h,
							n = '',
							m,
							t;
						m = A.La(new Date());
						q.URL
							? e.add('INTLOC', q.URL.split('?')[0])
							: q.documentURI && e.add('INTLOC', q.documentURI.split('?')[0]);
						e.add('STVER', W);
						e.add('BBNS', 'FP');
						g.enable_static_token && e.add('STTKN', ja.Na(m), !0);
						e.add('TZON', J.Oa().toString());
						l && l.userAgent && e.add('UAGT', l.userAgent.slice(0, 400));
						screen && e.add('JRES', screen.height + 'x' + screen.width);
						e.add('JENBL', '1');
						if ((a = new La()))
							e.add('JBRNM', a.s),
								e.add('JBRVR', a.version),
								e.add('JBROS', a.R);
						if (l) {
							if (ga) {
								h = l.plugins.length;
								for (d = 0; d < h; d++) n += l.plugins[d].filename + ';';
								e.add('JPLGNS', n);
							}
							e.add('JLANG', l.language || l.systemLanguage);
							e.add('JCOX', l.cookieEnabled ? '' : '1');
						}
						a &&
							((c = new RegExp('^.*' + a.R + ';? ?', 'g')),
							a.attributes &&
								((b = a.attributes.join('; ')),
								e.add('JBRCM', b.replace(c, ''))));
						e.add('JSTIME', m.substr(0, 19), !0);
						t = Fa('static');
						G(
							' { "staticStatus": ' +
								t.isUnex +
								", 'scriptList': \"" +
								t.scriptList +
								'" }',
						);
						e.add('MIST', t.scriptList);
						g.enable_atrip &&
						-1 === l.userAgent.indexOf(p.decode('RmlyZWZveC80NQ=='))
							? Ia(!1)
							: ea();
						g.enable_wstrip ? Za() : U();
						l &&
							(e.add('NPLAT', l.platform),
							e.add('APVER', l.appVersion),
							e.add('APNAM', l.appName),
							e.add('OSCPU', l.oscpu),
							e.add(
								'CCUR',
								l.hardwareConcurrency && l.hardwareConcurrency.toString(),
							),
							e.add('ULANG', l.userLanguage),
							e.add('BLANG', l.browserLanguage),
							e.add('NLANG', l.language),
							e.add('SLANG', l.systemLanguage));
						e.add('JREFRR', q.referrer);
						Ya();
						Xa();
						Wa();
						Va();
						D('mousemove', E);
						D('mousedown', E);
						D('mouseup', E);
						D('touchstart', E);
						D('touchend', E);
						D('keydown', E);
						D('keyup', E);
						D('wheel', E);
						D('scroll', E);
						D('pointermove', E);
						D('pointerdown', E);
						typeof g[f.V] === f.l && e.add('TRACE', '1');
						e.add('MRSID', p.encode(na(!1)));
						e.add('CRSID', p.encode(na(!0)));
						e.add('BBOUT', g[f.i]);
					} catch (z) {
						e.add('EMSG', k('io_sdp:', z, !0));
					}
				J.a = J.h && J.qa;
			},
		},
		K = (g.io_ddp = {
			label: 'io_ddp',
			a: !1,
			h: !1,
			w: !1,
			X: function () {
				var a = I;
				if (a) {
					K.h = !0;
					if (!K.a) {
						try {
							var b = a.nuidIndex,
								c = b && b.length,
								d,
								h,
								n,
								m;
							for (m = 0; m < c; m++)
								(h = a[b[m]]),
									(d = b[m].toUpperCase()),
									(n = Boolean(-1 < d.indexOf('TOKEN') || 'SVRTIME' === d)),
									e.add(d, h, n);
							l.userAgent === e.b.SUAGT
								? e.remove('SUAGT')
								: e.add('JDIFF', '1');
							if ((Q = e.b.JSTOKEN))
								O
									? Z(Q) || (e.remove('JSTOKEN'), e.add('JTERR', f.v + A.P(Q)))
									: (e.remove('JSTOKEN'), e.add('FLRTD', Q));
						} catch (q) {
							e.add(
								'EMSG',
								k(
									p.decode('aW9fZGRwOiBlcnJvciBoYW5kbGluZyBkeW4gZGF0YQ=='),
									q,
									!0,
								),
							);
						}
						K.a = !0;
					}
					K.w = !0;
				} else
					g[f.g] && g[f.g]['fp' + p.decode('X2R5bl93ZHBfbG9hZF9mYWlsdXJl')]
						? (K.a = !0)
						: ra
						? (K.a = !0)
						: k(
								p.decode('aW9fZGRwLmNvbGxlY3Q6IGlvX2R5bl9vYmogdW5kZWZpbmVk'),
								'',
								!0,
						  );
			},
			_if_ubb: function () {
				1 === O &&
					K &&
					K._CTOKEN &&
					(Z(K._CTOKEN)
						? e.add('CTOKEN', K._CTOKEN, !0)
						: e.add('CTERR', f.v + A.P(K._CTOKEN)));
			},
		});
	try {
		la('io_sdp', J),
			la('io_ddp', g.io_ddp),
			(pa = new Na('f604be51-ccf5-4d26-9cc2-3c44e1fdceb9')),
			la('io_ls', pa),
			g.enable_flash && ((Pa = new Ma()), la('io_fdp', Pa));
	} catch (a) {
		k('io_collect', a, !0);
	}
	var Sa = 0;
	qa ||
		(qa = setInterval(function () {
			var a = !1;
			(q.readyState &&
				'loaded' !== q.readyState &&
				'complete' !== q.readyState &&
				'interactive' !== q.readyState) ||
				(ta() || 30 < Sa ? (qa && clearInterval(qa), (a = !0)) : Sa++);
			return a;
		}, 100));
	q.addEventListener && q.addEventListener('DOMContentLoaded', ta, oa);
	(function () {
		g.api = {
			io_bb: {
				add: function (a, b) {
					return e.add(a, b);
				},
			},
			ds_cb: function (a) {
				var b, c, d;
				if ((I = a)) {
					c = I.jsver;
					a = I.jstoken;
					I.skey && (b = n.encodeURIComponent(I.skey));
					ma = (g.contentServerHost || '').replace(/\/+$/, '');
					d = ('/' + (g.contentServerPath || ''))
						.replace(/\/\//g, '/')
						.replace(/\/+$/, '');
					Aa = ('/' + (g.ctokenScriptPath || ''))
						.replace(/\/\//g, '/')
						.replace(/\/+$/, '');
					d && ((ca += d), (ca = ca.replace('/iojs', ha)));
					d = Fa('dyn');
					G(
						' { "dynStatus": ' +
							d.isUnex +
							", 'scriptList': \"" +
							d.scriptList +
							'" }',
					);
					O = !1 === d.isUnex ? 1 : 0;
					d.isUnex && e.add('FULOC', d.scriptList);
					d = /^\d+\.\d+\.\d+$/;
					(d.test(W) && d.test(c) && W.split('.')[0] === c.split('.')[0]) ||
						k('ver mismatch: ( S:' + W + ', D:' + c + ' )', void 0, !0);
					try {
						O && ((Q = a), pa && (pa.B = Q), g.enable_rtc && Ua());
					} catch (f) {
						k('', f, !0);
					}
					var h, l, m;
					a = '';
					c = W;
					Ra && (c = c.replace(/\./g, '-'));
					try {
						(h = q.getElementsByTagName('head')[0]),
							(l = q.createElement('script')),
							l.setAttribute('language', 'javascript'),
							l.setAttribute('type', 'text/javascript'),
							Aa
								? ((m = Aa),
								  (m = b
										? m.replace('latest', c + '/' + b)
										: m.replace('latest', c)),
								  (a += m),
								  (a = a.replace('/iojs', ha).replace(/\/\//g, '/')),
								  l.setAttribute('src', a),
								  h.appendChild(l))
								: k('unable to find logo.js url', void 0, !0);
					} catch (f) {
						k('', f, !0);
					}
				}
				ta();
			},
			sic: function () {
				return 0 === O;
			},
			logError: function (a, b, c) {
				return k(a, b, c);
			},
			decode: function (a) {
				return p.decode(a);
			},
			last_error: g[f.ba],
			stver: W,
		};
	})();
})();

/*
 Copyright(c) 2018, iovation, inc. All rights reserved.
*/
(function B() {
	function v(e, a) {
		var b = {},
			c;
		for (c = e.length - 1; -1 < c; c--)
			0 < c
				? (b[c] = (function () {
						var d = c;
						return function () {
							return w(e[d], b[d + 1], a);
						};
				  })())
				: w(e[c], b[c + 1], a);
	}
	function w(e, n, k) {
		var c = document.createElement('script'),
			f,
			g,
			l;
		l = A((a[k] && a[k].staticVer && a[k].staticVer + '/') || e[1]);
		e[0] = e[0].replace('##version##', l);
		f = e[0].split('?')[0].split('/');
		g = f[f.length - 1].split('.')[0];
		u.test(e[1]) &&
			l !== e[1] &&
			d('loader: Overriding configured version with staticVer.');
		c.setAttribute('src', e[0]);
		c && c.addEventListener
			? c.addEventListener('error', function () {
					b[k + '_' + g + '_load_failure'] = 'true';
			  })
			: c.attachEvent &&
			  c.attachEvent('onerror', function () {
					b[k + '_' + g + '_load_failure'] = 'true';
			  });
		n && (c.onload = n);
		document.getElementsByTagName('head')[0].appendChild(c);
	}
	function d(e) {
		if ('function' === typeof a.trace_handler)
			try {
				a.trace_handler(e);
			} catch (b) {}
	}
	function f(b, a) {
		var d = null !== b && void 0 !== b;
		return !d || ('1' !== b.toString() && 'true' !== b.toString().toLowerCase())
			? !d || ('0' !== b.toString() && 'false' !== b.toString().toLowerCase())
				? 'boolean' === typeof a
					? a
					: !1
				: !1
			: !0;
	}
	function A(a) {
		d('********** version before replace: ' + a + ' **********');
		d('localNamespace[ "url_dots_to_dashes" ]: ' + b.url_dots_to_dashes);
		d('numericVersionPattern.test( output ): ' + u.test(a));
		b.url_dots_to_dashes && u.test(a) && (a = a.replace(/\./g, '-'));
		d('version after replace: ' + a);
		return a;
	}
	var g = window,
		x = g.io_global_object_name || 'IGLOO',
		a = (g[x] = g[x] || {}),
		b = (a.loader = a.loader || {}),
		y = [],
		z = [],
		u = /^[0-9]{1,3}(\.[0-9]{1,3}){2}\/$/;
	if (b.loaderMain)
		return (
			d(
				"loader: Loader script has already run, try reducing the number of places it's being included.",
			),
			!1
		);
	b.loaderMain = B;
	b.loaderVer = '5.2.2';
	(function () {
		var e = f(b.tp, !0),
			n = f(b.fp_static, !0),
			k = f(b.fp_dyn, !0),
			c = f(b.enable_legacy_compatibility),
			u = f(b.tp_split),
			v =
				(b.tp_host && b.tp_host.replace(/\/+$/, '')) ||
				'https://mpsnare.iesnare.com',
			l = b.fp_static_override_uri,
			m = void 0 !== b.uri_hook ? b.uri_hook + '/' : '/iojs/',
			p = (b.version || 'versionOrAliasIsRequired') + '/',
			w = b.subkey ? g.encodeURIComponent(b.subkey) + '/' : '',
			x = b.tp_resource || 'wdp.js',
			q = b.tp_host ? '&tp_host=' + g.encodeURIComponent(b.tp_host) : '',
			C = l ? '&fp_static_uri=' + g.encodeURIComponent(l) : '',
			r,
			t,
			h;
		b.tp_host = v;
		r = f(a.enable_flash, !0);
		t = a.io && a.io.enable_flash;
		h = a.fp && a.fp.enable_flash;
		t = void 0 !== t && null !== t ? f(t, !0) : r;
		void 0 !== h && null !== h ? (h = f(h, !0)) : (t = r);
		r = t ? '&flash=true' : '&flash=false';
		h = h ? '&flash=true' : '&flash=false';
		q =
			'?loaderVer=' +
			b.loaderVer +
			'&compat=' +
			c +
			'&tp=' +
			e +
			'&tp_split=' +
			u +
			q +
			'&fp_static=' +
			n +
			'&fp_dyn=' +
			k +
			C;
		e ||
			n ||
			d('loader: Not currently configured to load fp_static or tp script(s).');
		a.fp &&
			a.fp.staticVer &&
			a.fp.staticVer + '/' !== p &&
			((p = A(a.fp.staticVer + '/')),
			d(
				'loader: Configured version replaced with that from pre-loaded static script.',
			));
		n || (a.fp && a.fp.staticMain)
			? ((m = (m + '##version##' + w).replace(/\/\//g, '/')),
			  n &&
					(a.fp && a.fp.staticMain
						? c &&
						  !a.fp.preCompatMain &&
						  d(
								'loader: enable_legacy_compatibility on, but included static does not have the compat wrapper.',
						  )
						: l
						? y.push([l, ''])
						: y.push([m + 'static_wdp.js' + q + h, p])),
			  !k || (a.fp && a.fp.dynMain)
					? a.fp &&
					  a.fp.dynMain &&
					  d(
							"loader: First party dynamic script has already been loaded, disable fp_dyn or make sure you're not manually including the dynamic file separately.",
					  )
					: y.push([m + 'dyn_wdp.js' + q + h, p]))
			: f(b.fp_dyn) &&
			  d(
					'loader: Invalid Config, first party dynamic script set to load without static.',
			  );
		e &&
			(a.io && a.io.staticMain
				? d('loader: Third party script has already been loaded.')
				: ((m = v + '/##version##' + w),
				  u
						? (z.push([m + 'static_wdp.js' + q + r, p]),
						  z.push([m + 'dyn_wdp.js' + q + r, p]),
						  b.tp_resource &&
								d(
									'loader: Invalid Config: both tp_resource and tp_split set. Ignoring tp_resource.',
								))
						: z.push([m + x + q + r, p])));
	})();
	v(y, 'fp');
	v(z, 'io');
})();
